'use strict';

module.exports = "js0.6.10";



/*****************
 ** WEBPACK FOOTER
 ** ../~/avoscloud-sdk/lib/version.js
 ** module id = 11
 ** module chunks = 0
 **/